import { ROUTES } from '@/constants/routes'

export default function checkWorkspace({ next, router, store }) {
    if (!store.workspaces.length) {
        return router.push({ name: ROUTES.notFoundWorkspace })
    }

    next()
}
